import { INamedItem } from '../types/resourceParts';
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ContentLineageRelationship } from '../types/ContentLineageRelationship';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { LineageRelationshipType, RelatedContentType } from '~src/ts/models/ContentLineageRelationshipInfo';

export type GetContentLineageRelationshipsParams = {
  readonly id: string;
  readonly contentType: RelatedContentType;
  readonly lineageRelationshipType: LineageRelationshipType;
}

export type GetContentLineageRelationshipsResult = IResult & {
  readonly contentLineageRelationships: ReadonlyArray<ContentLineageRelationship>;
  readonly backfillRunning: boolean;
};

export class GetContentLineageRelationshipsRequest extends Request<GetContentLineageRelationshipsParams, GetContentLineageRelationshipsResult> {
  constructor(params: GetContentLineageRelationshipsParams) {
    super('getContentLineageRelationships', params);
  }
}
